
import { Component, OnInit, ViewContainerRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgModule } from '@angular/core';
//import {ConstantMessages} from '../common/ConstantMessages';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { Constants } from 'src/app/common/Constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
declare function unescape(s: string): string;

declare var $: any;
// $.navigation = $('#header-menu');
@Component({
  selector: 'Login',
  templateUrl: './Login.component.html',
  styleUrls: ['./Login.component.scss'],
  // providers: [HTTPService, MessageService]
})


export class LoginComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  provider: string;
  userDetails: any = {};
  registerUserDetails: any = {};
  MenuFunctionObj: any = {};
  spinnerVisible: boolean = false;
  constants: any;
  constantMessages: any;
  constErrors: any;
  MenuList: any = [];
  messageType: any;

  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  isLogin: boolean = true;

  signUpForm: FormGroup;
  signUpSubmitted = false;
  isWaitingForLogin = false;
  public user;
  sub: any;
  @Input() isFromSellerLogin: boolean = false;
  @Input() name: string = "";
  @Input() phone: string = "";
  @Input() email: string = "";
  isCurrentlyLogin = false;
  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.India, CountryISO.UnitedStates, CountryISO.UnitedKingdom, CountryISO.UnitedArabEmirates];
  constructor(public activeModal: NgbActiveModal, private dialog: MatDialog, private _httpService: HTTPService, private _route: ActivatedRoute,
    private _router: Router, private _formBuilder: FormBuilder, private sharedService: SharedService, public toastr: ToastrService, private socialAuthService: SocialAuthService) {
    this.constants = new Constants();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      username: [this.name, Validators.required],
      password: ['', Validators.required]
    });

    this.signUpForm = this._formBuilder.group({
      name: [this.name, Validators.required],
      phone: [this.phone],
      username: [this.email, Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });

    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    if (localStorage.getItem("userDetails") !== null) {
      this.isCurrentlyLogin = true;
    }
    this.socialAuthService.authState.subscribe((user) => {

      if (localStorage.getItem("userDetails") === null) {

        this.user = user;
        this.provider = user["provider"];
        localStorage.setItem("provider", this.provider);
        this.userDetails = { 'username': user["email"], 'password': null, 'provider': this.provider, 'name': user["name"] };
        this._httpService.ajaxPost("homepage/Login", this.userDetails).subscribe(
          data => {
            this.isWaitingForLogin = false;
            if (data["Message"].MessageTypeValue == this.constants.messageType.Success) {
              if (this.user.image != undefined && this.user.image != null && this.user.image != '') {
                data["Response"].ProfileImage = this.user.image;
                $("#profileImageTag").attr('src', data["Response"].ProfileImage);
              }
              localStorage.setItem("userDetails", JSON.stringify(data["Response"]));

              this.dialog.closeAll();
              this.activeModal.close();
              //location.reload();
              this.sharedService.loginMessageSubject.next(true);
              this.processPostLogin();
            }
            if (data["Message"].MessageTypeValue == this.constants.messageType.Error)
              this.toastr.error(data["Message"].Text);
            //this._router.navigate([this.returnUrl]);
            this.hideSpinner();
          },
          (error: any) => {
            //this.toastr.error(error);
            this.hideSpinner();
            this.isWaitingForLogin = false;
          },
          () => { });
      }
      else {
        this.toastr.error("user already loggedin");
        //alert("user already loggedin");	
      }

    });
    //$('#myModal').modal('show');
  }
  showSpinner() {
    this.spinnerVisible = true;
  }
  closeVideoPreview() {
    this.activeModal.close();
  }
  hideSpinner() {
    this.spinnerVisible = false;
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }
  get r() { return this.signUpForm.controls; }

  onSubmit() {
    if (localStorage.getItem("userDetails") === null) {
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
        return;
      }

      this.showSpinner();
      // this.authenticationService.login(this.f.username.value, this.f.password.value)
      //     .pipe(first())
      //     .subscribe(
      //         data => {
      //             this._router.navigate([this.returnUrl]);
      //         },
      //         error => {
      //             this.toastr.error(error);
      //             this.hideSpinner();
      //         });
      this.provider = 'local';
      localStorage.setItem("provider", this.provider);
      this.userDetails = { 'username': this.f.username.value, 'password': this.f.password.value, 'provider': this.provider, 'name': null };
      // this._router.navigate([this.returnUrl]);
      this.ProcessLogin();
    }
    else {
      this.dialog.closeAll();
      this.activeModal.close();
      this.toastr.error("user already loggedin");
      //alert("user already loggedin");	

    }
  }

  private ProcessLogin() {
    this.isWaitingForLogin = true;
    this.subscription.add(
      this._httpService.ajaxPost("homepage/Login", this.userDetails).subscribe(
        data => {

          if (data["Message"].MessageTypeValue == this.constants.messageType.Success) {
            localStorage.setItem("userDetails", JSON.stringify(data["Response"]));
            this.userDetails = JSON.parse(localStorage.getItem("userDetails"));

            if (data["Response"].ProfileImage != null && data["Response"].ProfileImage != "") {
              $("#profileImageTag").attr('src', data["Response"].ProfileImage);
            }
            this.sharedService.loginMessageSubject.next(true);
            if (this.isFromSellerLogin) {
              let updateUserObject = Object.assign({});
              updateUserObject.UserId = this.userDetails.UserId;
              updateUserObject.IsSeller = true;
              this._httpService.ajaxPost("Homepage/UpdateIsSellerStatus", updateUserObject).subscribe((data: any) => {
                this.dialog.closeAll();
                this.sharedService.isUserASeller = true;
                this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
                this.userDetails.IsSeller = true;
                localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
                this._router.navigate(['/user/affiliateconsole']);
              });
            }
            else {
              this.dialog.closeAll();
            }
            this.processPostLogin();
            this.activeModal.close(true);
            //location.reload();
          }
          if (data["Message"].MessageTypeValue == this.constants.messageType.Error)
            this.toastr.error(data["Message"].Text);
          //this._router.navigate([this.returnUrl]);
          this.hideSpinner();
          this.isWaitingForLogin = false;
        },
        (error: any) => {
          this.toastr.error(error);
          this.hideSpinner();
          this.isWaitingForLogin = false;
        },
        () => { }));
  }
  processPostLogin() {
    this.trackClarityEvent(this.userDetails.Email, this.userDetails.Phone);
  }
  private trackClarityEvent(email: string, phone: string): void {
    if (window.clarity) {
      try {
        (window as any).clarity("set", "email", email);
        (window as any).clarity("set", "phone", phone);
      } catch (error) {
      }
    } else {
      console.warn("Clarity is not available.");
    }
  }
  switchLoginForm(id) {
    if (id == 1)
      this.isLogin = false;
    if (id == 2)
      this.isLogin = true;
  }


  onRegisterSubmit() {
    this.signUpSubmitted = true;
    // stop here if form is invalid
    if (this.signUpForm.invalid || this.signUpForm.controls["password"].value != this.signUpForm.controls["confirmPassword"].value) {
      return;
    }

    this.showSpinner();

    this.registerUserDetails = { 'username': this.r.username.value, 'phone': this.r.phone.value.number, 'phoneCountryCode': this.r.phone.value.dialCode,
      'password': this.r.password.value, 'provider': 'local', 'name': this.r.name.value, 'isseller': this.isFromSellerLogin,  };
    //UserId Name Email Password MobileNo DOB ProfileImage Nationality CreatedDate

    //this._router.navigate([this.returnUrl]);
    this.subscription.add(
      this._httpService.ajaxPost("homepage/Register", this.registerUserDetails).subscribe(
        data => {
          if (data["MessageTypeValue"] == "1") {
            this.toastr.error(data["Text"]);
          }
          else {
            this.isLogin = true;
            this.toastr.success("User Registered Successfully");
            this.provider = 'local';
            localStorage.setItem("provider", this.provider);
            this.userDetails = { 'username': this.r.username.value, 'password': this.r.password.value, 'provider': this.provider, 'name': null };
            // this._router.navigate([this.returnUrl]);
            this.ProcessLogin();
            // this.sharedService.isUserASeller = this.isFromSellerLogin;
            // this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
            // this.userDetails.IsSeller = this.isFromSellerLogin;
            // localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
          }
          //           this._router.navigate([this.returnUrl]);
          this.hideSpinner();
        },
        (error: any) => {
          //   this.toastr.error(error);
          this.hideSpinner();
        },
        () => { }));
  }

  googleloginfunction() {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
    //TODO
    // if (localStorage.getItem("userDetails") === null) {
    //   this.isWaitingForLogin = true;
    //   this.sub = this.subscription.add(this._auth.login("google").subscribe(
    //     (data) => {
    //       this.user = data;
    //       this.provider = data["provider"];
    //       localStorage.setItem("provider", this.provider);
    //       this.userDetails = { 'username': data["email"], 'password': null, 'provider': this.provider, 'name': data["name"] };
    //       this._httpService.ajaxPost("homepage/Login", this.userDetails).subscribe(
    //         data => {
    //           this.isWaitingForLogin = false;
    //           if (data["Message"].MessageTypeValue == this.constants.messageType.Success) {
    //             if (this.user.image != undefined && this.user.image != null && this.user.image != '') {
    //               data["Response"].ProfileImage = this.user.image;
    //               $("#profileImageTag").attr('src', data["Response"].ProfileImage);
    //             }
    //             localStorage.setItem("userDetails", JSON.stringify(data["Response"]));
    //             localStorage.setItem("userLoginTime", Date.now().toString());

    //             this.dialog.closeAll();
    //             //location.reload();
    //             this.sharedService.loginMessageSubject.next(true);
    //           }
    //           if (data["Message"].MessageTypeValue == this.constants.messageType.Error)
    //             this.toastr.error(data["Message"].Text);
    //           //this._router.navigate([this.returnUrl]);
    //           this.hideSpinner();
    //         },
    //         (error: any) => {
    //           //this.toastr.error(error);
    //           this.hideSpinner();
    //           this.isWaitingForLogin = false;
    //         },
    //         () => { });
    //     }
    //   ));
    // }
    // else {
    //   this.toastr.error("user already loggedin");
    //   //alert("user already loggedin");	
    // }
  }

  goto(screen: any) {
    switch (screen) {
      case 'signup':
        break;
      default:
        break;
    }

  }
  forgetPassword() {
    this._router.navigate(['user/forgetpassword']);
  }
}


